import React from "react";

// Kısıtlı markdown render: ## / # başlık, - / * madde, **kalın**, paragraf.
// DeepSeek özet formatı için yeterli; harici kütüphane yok.
function renderInline(text: string, keyPrefix: string): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  const re = /\*\*(.+?)\*\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(<strong key={`${keyPrefix}-b${i++}`}>{m[1]}</strong>);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export default function SummaryMarkdown({ source, className }: { source: string; className?: string }) {
  const lines = (source || "").replace(/\r\n/g, "\n").split("\n");
  const blocks: React.ReactNode[] = [];
  let list: string[] = [];
  let k = 0;

  const flushList = () => {
    if (!list.length) return;
    const items = list;
    list = [];
    blocks.push(
      <ul className="smd-ul" key={`ul-${k++}`}>
        {items.map((it, idx) => (
          <li className="smd-li" key={`li-${k}-${idx}`}>{renderInline(it, `li-${k}-${idx}`)}</li>
        ))}
      </ul>
    );
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (line === "") { flushList(); continue; }
    if (line.startsWith("## ")) {
      flushList();
      blocks.push(<h3 className="smd-h3" key={`h-${k++}`}>{renderInline(line.slice(3).trim(), `h-${k}`)}</h3>);
    } else if (line.startsWith("# ")) {
      flushList();
      blocks.push(<h2 className="smd-h2" key={`h-${k++}`}>{renderInline(line.slice(2).trim(), `h-${k}`)}</h2>);
    } else if (line.startsWith("- ") || line.startsWith("* ")) {
      list.push(line.slice(2).trim());
    } else {
      flushList();
      blocks.push(<p className="smd-p" key={`p-${k++}`}>{renderInline(line, `p-${k}`)}</p>);
    }
  }
  flushList();

  return (
    <div className={`smd-root ${className || ""}`}>
      {blocks}
      <style>{SMD_CSS}</style>
    </div>
  );
}

const SMD_CSS = `
.smd-root { font-size: 14px; line-height: 1.6; color: #e8eef5; }
.smd-h2 { font-size: 17px; font-weight: 700; margin: 16px 0 8px; color: #fff; }
.smd-h3 { font-size: 15px; font-weight: 700; margin: 16px 0 6px; color: #1ed760; letter-spacing: .2px; }
.smd-root .smd-h3:first-child, .smd-root .smd-h2:first-child { margin-top: 0; }
.smd-p { margin: 6px 0; }
.smd-ul { margin: 6px 0 10px; padding-left: 20px; list-style: none; }
.smd-li { position: relative; margin: 4px 0; padding-left: 4px; }
.smd-li::before { content: "•"; color: #1db954; position: absolute; left: -14px; font-weight: 700; }
.smd-root strong { color: #fff; font-weight: 700; }
`;
